import React, { useEffect, useState, useCallback } from 'react';
import Countdown from './Countdown';

function levelLabel(lvl) {
  if (lvl === 1) return 'Nível 1 (15 min)';
  if (lvl === 2) return 'Nível 2 (30 min)';
  if (lvl >= 3) return `Nível ${lvl} (1 h)`;
  return 'Nível desconhecido';
}

function levelColorClass(lvl) {
  if (lvl === 1) return 'ab-card-lvl1';
  if (lvl === 2) return 'ab-card-lvl2';
  if (lvl >= 3) return 'ab-card-lvl3';
  return '';
}

function driftBadge(status) {
  if (status === 'db_only_stale') return <span className="ab-badge ab-badge-warn">drift — aguardando reconciler</span>;
  if (status === 'jail_unreachable') return <span className="ab-badge ab-badge-info">jail indisponível</span>;
  return null;
}

function copyToClipboard(text) {
  if (navigator.clipboard) navigator.clipboard.writeText(text).catch(() => {});
}

function BanCard({ ban, now, onUnban, onWhitelist, busy }) {
  const dryRun = ban.event_type === 'dry_run' || ban.source === 'dry_run';
  const colorClass = levelColorClass(ban.escalation_level);
  return (
    <div className={`ab-ban-card ${colorClass}`}>
      {dryRun && (
        <div className="ab-dry-run-banner">⚠ DRY-RUN — registrado, mas não bloqueado</div>
      )}
      <div className="ab-card-header">
        <span className={`ab-badge ab-badge-src-${ban.source || 'fail2ban'}`}>{ban.source || 'fail2ban'}</span>
        {driftBadge(ban.drift_status)}
      </div>
      <div className="ab-ip">{ban.ip}</div>
      <div className="ab-jail">{ban.jail}</div>
      <div className="ab-countdown-box">
        <Countdown now={now} expiresAt={ban.expires_at} />
        <div className="ab-countdown-label">restante</div>
      </div>
      <div className="ab-meta">
        <strong>{ban.escalation_level ? levelLabel(ban.escalation_level) : 'Nível pendente'}</strong>
        {ban.bancount_at_ban ? ` · ${ban.bancount_at_ban}ª reincidência` : ''}
      </div>
      <div className="ab-meta">
        Banido {new Date(ban.banned_at).toLocaleString('pt-BR')}
      </div>
      {ban.correlation_id && (
        <div className="ab-correlation" title="Clique para copiar correlation_id">
          <button
            type="button"
            className="ab-correlation-btn"
            onClick={() => copyToClipboard(ban.correlation_id)}
          >
            corr: {ban.correlation_id.slice(0, 8)}…
          </button>
        </div>
      )}
      <div className="ab-actions">
        <button
          type="button"
          className="ab-btn-unban"
          onClick={() => onUnban(ban)}
          disabled={busy}
        >
          🔓 Desbloquear
        </button>
        <button
          type="button"
          className="ab-btn-whitelist"
          onClick={() => onWhitelist(ban)}
          disabled={busy}
        >
          ✓ Whitelist
        </button>
      </div>
    </div>
  );
}

function AutoBlockActiveBans({ activeBans, busy, onUnban, onWhitelist }) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  if (!activeBans || activeBans.length === 0) {
    return (
      <div className="ab-empty">
        Nenhum IP banido ativamente. A jail está observando logs em modo configurado.
      </div>
    );
  }

  return (
    <div className="ab-active-grid">
      {activeBans.map((ban) => (
        <BanCard
          key={ban.id}
          ban={ban}
          now={now}
          busy={busy}
          onUnban={onUnban}
          onWhitelist={onWhitelist}
        />
      ))}
    </div>
  );
}

export default AutoBlockActiveBans;
